import { render, staticRenderFns } from "./appHeader.vue?vue&type=template&id=33c3c825&scoped=true"
import script from "./appHeader.vue?vue&type=script&lang=js"
export * from "./appHeader.vue?vue&type=script&lang=js"
import style0 from "./appHeader.vue?vue&type=style&index=0&id=33c3c825&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c3c825",
  null
  
)

/* custom blocks */
import block0 from "./appHeader.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports